import styled from 'styled-components';

const Container = styled('div')`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 704px;
`;

export default Container;
